import script from "./AlarmSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./AlarmSearch.vue?vue&type=script&setup=true&lang=js"

import "./AlarmSearch.vue?vue&type=style&index=0&id=d35d6670&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d35d6670"]])

export default __exports__